import React, { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import SchoolCard from "./SchoolCard";
import getArrayIntersection from "../../../helpers/getArrayIntersection";
import getSchoolActiveCategoriesSelector from "../../../state/selectors/SchoolSelectors/getSchoolActiveCategoriesSelector";
import getSchoolsSelector from "../../../state/selectors/SchoolSelectors/getSchoolsSelector";
import setSchoolAction from "../../../state/actions/SchoolActions/setSchoolAction";
import styled from "styled-components";

const Schools: React.FC = () => {
    const dispatch = useDispatch();
    const setSchool = useCallback((school: School) => dispatch(setSchoolAction(school)), [dispatch]);
    const schools = useSelector((state: Store) => getSchoolsSelector(state));
    const activeCategories = useSelector((state: Store) => getSchoolActiveCategoriesSelector(state));
    const contents =
        activeCategories.length === 0
            ? schools
            : schools.filter(school => {
                  const categories = school.categories.map(category => category.term_id);
                  if (getArrayIntersection([categories, activeCategories]).length) {
                      return school;
                  }
                  return null;
              });
    return (
        <Container>
            {contents.map(school => {
                return (
                    <SchoolCard
                        onClick={() => setSchool(school)}
                        key={school.ID}
                        id={school.ID}
                        title={school.post_title}
                        order={school.order}
                        name={school.post_name}
                        description={school.fields.what_to_study}
                        categories={school.categories.map(category => category.name).join(", ")}
                    />
                );
            })}
        </Container>
    );
};

export default Schools;

const Container = styled.div`
    padding: 1rem;
    width: 100%;
`;
